import React, { PureComponent } from 'react';
import filter from 'lodash/filter';
import { withRouter } from 'react-router';
// import { css } from 'react-emotion';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Loading from '../../components/Loading';
import { OrgAdminSubscriptionItem } from '../../views/Admin/SubscriptionItem';
import '../../styles/Stripe.css';

const availablePlans = organizationPlans =>
  organizationPlans &&
  organizationPlans.reduce(
    (p, c) => ({
      ...p,
      [c.plan.id]: c.quantityAvailable,
    }),
    {},
  );

// const plansList = (organizationPlans, subscriptions) => {
//   console.log(subscriptions);

//   return organizationPlans.map((p, idx) => {
//     let qty = (
//       <span className="badge badge-primary badge-pill">
//         {p.quantityAvailable < 0 ? 0 : p.quantityAvailable}
//       </span>
//     );
//     if (p.plan.name === 'Individual') {
//       qty = <span className="badge" style={{ fontSize: 18, lineHeight: 1 }}>&infin;</span>;
//     }
//     return (
//       <li
//         key={idx}
//         className="list-group-item d-flex justify-content-between align-items-center"
//       >
//         {p.plan.name}
//         {qty}
//       </li>
//     );
//   });
// };

const queryOrganizationSubscriptions = gql`
  query organizationSubscriptions($organizationId: ID!) {
    organizationSubscriptions(organizationId: $organizationId) {
      id
      payment_type
      card {
        brand
        exp_month
        exp_year
        last4
      }
      cancel_at_period_end
      created_at
      updated_at
      deleted_at
      restored_at
      items {
        id
        subscription_id
        plan_id
        plan {
          id
          name
          interval
          amount
        }
        qty
        created_at
        updated_at
        restored_at
        deleted_at
      }
    }
    organizationPlans(organizationId: $organizationId) {
      plan {
        id
        name
      }
      quantityAvailable
    }
    cards(organizationId: $organizationId) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
    }
  }
`;

const withData = graphql(queryOrganizationSubscriptions, {
  options: ({ params }) => ({
    variables: {
      organizationId: params.organizationId,
    },
    fetchPolicy: 'network-only',
  }),
});

@withRouter
@withData
class SubscriptionsList extends PureComponent {
  getDefaultCard = cardsList => {
    const result = filter(cardsList, { is_default: true });
    return result;
  };

  render() {
    const {
      data: { organizationPlans, organizationSubscriptions, loading },
      params: { organizationId },
    } = this.props;
    // console.log('> ', this.props);
    if (loading) return <Loading />;
    // const defaultCard = this.getDefaultCard(cards);
    // console.log('def card', this.props);
    const availableInventory = availablePlans(organizationPlans);
    const output = !organizationSubscriptions ? (
      <span>You currently have no subscriptions.</span>
    ) : (
      <div className="row">
        <div className="col-12">
          <h2>Subscriptions</h2>
          <table
            className="table table-hover"
            style={{ fontFamily: 'Arial', fontSize: 14 }}
          >
            <thead>
              <tr>
                <th scope="col">Status</th>
                <th scope="col">Purchased</th>
                <th scope="col">Created</th>
                <th scope="col">Total Available</th>
              </tr>
            </thead>
            <tbody>
              {organizationSubscriptions.map(subscription => (
                <OrgAdminSubscriptionItem
                  key={subscription.id}
                  organizationId={organizationId}
                  subscription={subscription}
                  availablePlans={availableInventory}
                  disableAdminFeatures
                />
              ))}
            </tbody>
          </table>
        </div>
        {/* <div className="col-4">
          <h2>Available Plans</h2>
          <ul className="list-group">{availablePlans}</ul>
        </div> */}
      </div>
    );

    return <div>{output}</div>;
  }
}

export default class OrganizationSubscriptions extends PureComponent {
  render() {
    const { params: { accountId } } = this.props;
    return <SubscriptionsList {...this.props} accountId={accountId} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/Organization/OrganizationSubscriptions.js